import script from "./ShareProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareProfile.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__